import apiClient from '../client.js'

export const settingsAPI = {
  // Public settings endpoints
  async getPublicSettings() {
    const response = await apiClient.get('/settings/public')
    return response.data
  },

  async getMaintenanceStatus() {
    const response = await apiClient.get('/maintenance')
    return response.data
  },

  // Admin maintenance mode
  async toggleMaintenance(enabled = null) {
    const payload = enabled !== null ? { enabled } : {}
    const response = await apiClient.patch('/admin/maintenance', payload)
    return response.data
  },

  // Game on the maintenance page: 'spice-jar' or 'flappy' (feature flappy)
  async setMaintenanceGame(game) {
    const response = await apiClient.put('/admin/maintenance/game', { game })
    return response.data
  },

  // Admin-v2 "Nastavenia": { maintenance, game, launch_at, orders_registered_only }
  async getShopSettings() {
    const response = await apiClient.get('/admin/shop-settings')
    return response.data
  },

  // { launch_at?: ISO string | null, orders_registered_only?: boolean }
  async updateShopSettings(settings) {
    const response = await apiClient.put('/admin/shop-settings', settings)
    return response.data
  },

  // Admin settings endpoints
  async getSettings(params = {}) {
    const response = await apiClient.get('/admin/settings', { params })
    return response.data
  },

  async createSetting(settingData) {
    const response = await apiClient.post('/admin/settings', settingData)
    return response.data
  },

  async getSettingGroups() {
    const response = await apiClient.get('/admin/settings/groups')
    return response.data
  },

  async getSettingsByGroup(group) {
    const response = await apiClient.get(`/admin/settings/group/${group}`)
    return response.data
  },

  async getSetting(key) {
    const response = await apiClient.get(`/admin/settings/${key}`)
    return response.data
  },

  async updateMultipleSettings(settingsData) {
    const response = await apiClient.put('/admin/settings', settingsData)
    return response.data
  },

  async updateSetting(key, settingData) {
    const response = await apiClient.put(`/admin/settings/${key}`, settingData)
    return response.data
  },

  async deleteSetting(key) {
    const response = await apiClient.delete(`/admin/settings/${key}`)
    return response.data
  },

  async resetSettings(resetData = {}) {
    const response = await apiClient.post('/admin/settings/reset', resetData)
    return response.data
  }
}
